import { z } from 'zod';
// Tells the SPA whether the MCP (Model Context Protocol) integration is wired
// and, when it is, the server URL a Claude client connects to. Mirrors the
// dark-until-provisioned PaymentConfigResponse contract: until an operator
// provisions the MCP Auth0 audience + Cloud Run secret, the endpoint reports
// `enabled: false` (and `url: null`) so the portal keeps the surface dark.
export const McpConfigResponseSchema = z.object({
    enabled: z.boolean(),
    url: z.string().nullable(),
});
